var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "component-checkmark" } }, [
    _c(
      "svg",
      {
        attrs: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 150.2 150.2",
        },
      },
      [
        _c("circle", {
          staticClass: "path circle",
          attrs: {
            fill: "none",
            stroke: "#2cbda8",
            "stroke-width": "18",
            "stroke-miterlimit": "10",
            cx: "75.1",
            cy: "75.1",
            r: "62.1",
          },
        }),
        _vm._v(" "),
        _c("polyline", {
          staticClass: "path check",
          attrs: {
            fill: "none",
            stroke: "#2cbda8",
            "stroke-width": "18",
            "stroke-linecap": "round",
            "stroke-miterlimit": "10",
            points: "103.2,55.2 61.5,98.8 39.8,77.5 ",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }